import { useSyncExternalStore } from 'react';
export type WalletType = 'applepay' | 'googlepay';
const subscribe = () => () => {};
const hasApplePay = () => typeof window !== 'undefined' && 'ApplePaySession' in window;
const serverSnapshot = () => false;
export function usePreferredWallet() {
  const isAppleDevice = useSyncExternalStore(subscribe, hasApplePay, serverSnapshot);
  return isAppleDevice ? "applepay" : "googlepay";
}